import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {setPasswordErrorAction} from '../../../store/actions/roomProtection.actions';
import {TypedTranslation} from '../../../i18n';

interface PasswordInputWithErrorProps {
    value: string;
    setValue: (value: string) => void;
    error: TypedTranslation | null;
}

function PasswordInputWithError({value, setValue, error}: PasswordInputWithErrorProps): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    return (
        <>
            <label htmlFor="password-input">{t('form.password')}</label>
            <input
                type="password"
                id="password-input"
                className={`c-inputElement__input ${error ? 'c-inputElement__input--error' : ''}`}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                    dispatch(setPasswordErrorAction(null));
                }}
                data-cy="password_input"
            />
            {error && (
                <span className="c-inputElement__error" data-cy="password_error">
                    {t(error)}
                </span>
            )}
        </>
    );
}

export default PasswordInputWithError;
